const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  currencyDisplay: 'symbol',
});

const formatMoney = (priceInCents: number) => {
  return currencyFormatter.format(priceInCents / 100);
};

export { formatMoney };
